exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2EHzEyBE{display:-webkit-box;display:-ms-flexbox;display:flex;list-style-type:none;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._2EHzEyBE._1NPBC9gE{padding:0;-webkit-padding-start:5px;-moz-padding-start:5px;padding-inline-start:5px}._2EHzEyBE._1NPBC9gE li{padding:0 2px}._2EHzEyBE._2hdU3auW{padding:0 11px 8px;-webkit-padding-start:40px;-moz-padding-start:40px;padding-inline-start:40px}._2EHzEyBE ._29dlv7SJ{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}._2EHzEyBE ._2PnmJ_0A{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}._3uEcovSG div span{font-size:18px;vertical-align:middle}._1VXTf1Re{line-height:34px;margin:8px 0;padding:0 8px;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}", ""]);

// exports
exports.locals = {
	"component": "_2EHzEyBE",
	"small-section": "_1NPBC9gE",
	"big-section": "_2hdU3auW",
	"left": "_29dlv7SJ",
	"right": "_2PnmJ_0A",
	"icon-size": "_3uEcovSG",
	"section": "_1VXTf1Re"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[hash:base64:8]"}!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist!./src/note/bar/style.less
// module id = 1326
// module chunks = 3